export class IAccess{  
    access_token: string;
    instance_url: string;
    userId: string;
    token_type: string;
    issued_at: string;
    signature: string;
    email:string;
    constructor()
    {
        // this.access_token=access_token;
        // this.userId=userId;
    }
}
